<script lang="ts">
	import { createSortable, type CreateSortableInput } from "@dnd-kit/svelte/sortable";
	import { Helper, Input, Label } from "flowbite-svelte";
	import type { SocialLink } from "#gen/bundles/v1/contact_pb.js";
	import Icon from "#lib/components/Icon.svelte";
	import { socialIcons } from "#lib/iconProvider.js";
	import { getSocialLinkURL, getSocialName, parseIdFromLink } from "#lib/social.js";
	import Button from "#lib/ui/Button/index.js";

	interface Props extends CreateSortableInput {
		link: SocialLink;
		error?: unknown;
		onInput?: (link: SocialLink, index: number) => void;
		onChange?: (link: SocialLink, index: number) => void;
		onRemove?: (link: SocialLink, index: number) => void;
	}

	let { id, index, link, error, onRemove, onInput, onChange, ...rest }: Props = $props();

	const { attach, attachHandle } = $derived(
		createSortable({
			...rest,
			get id() {
				return id;
			},
			get index() {
				return index;
			},
			get data() {
				return link;
			},
		}),
	);
	const icon = $derived(socialIcons.get(link.type));

	function handleInput(e: Event) {
		const input = e.target as HTMLInputElement;
		link.id = getSocialLinkURL(link.type, input.value);
		onInput?.(link, index);
	}

	function handleChange() {
		onChange?.(link, index);
	}

	function handleRemove() {
		onRemove?.(link, index);
	}
</script>

<div {@attach attach} class="flex items-center gap-2 rounded-xl border bg-white p-4">
	<div {@attach attachHandle} aria-label="drag-handle for {link.id}" class="flex-none">
		<Icon iconSet="mingcute" name="dots-line" />
	</div>
	<Icon iconSet={icon?.iconSet} name={icon?.icon} class="h-6 w-6" />
	<Label class="w-72 font-medium" for="social-{index}">{getSocialName(link.type)}</Label>
	<div class="grow">
		<Input color={error ? "red" : "base"} id="social-{index}" name="social-{index}" placeholder="Enter your username or URL" value={parseIdFromLink(link)} on:input={handleInput} on:change={handleChange} />
		{#if error}
			<Helper class="mt-2" color="red"><span class="font-medium">{error}</span></Helper>
		{/if}
	</div>
	<Button color="none" class="p-0" data-action-name="contact-details-remove-social-link" on:click={handleRemove}>
		<Icon iconSet="heroicons" name="trash" class="h-5 w-5" />
	</Button>
</div>
